import { useTheme } from '@mui/material/styles';
import grey from '@mui/material/colors/grey';


export const ErrorLogStyles = () => {
  const theme = useTheme();

  return ({
    background: grey[50],
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    padding: {
      xs: "20px",
      md: "40px",
    },
    position: "relative",
    "&.friendly-error svg": {
      margin: "auto",
    },
    "& .error__title": {
      color: theme.palette.primary.light,
      marginBottom: "6px",
    },

    "& .error__url": {
      fontSize: ".84rem",
      fontStyle: "italic",
    },

    "& .error__wrong-type": {
      fontStyle: "italic",
    },
    "& p": {
      margin: "6px"
    }
  })
}
